<script setup lang="ts">
import { useI18n } from '@/i18n';
import type Stripe from 'stripe';
import { computed } from 'vue';
import BillingCardBrandIcon from '@/components/BillingCardBrandIcon/BillingCardBrandIcon.vue';
import BillingLinkBrandIcon from '@/components/BillingLinkBrandIcon/BillingLinkBrandIcon.vue';

const props = defineProps<{
  method: Stripe.PaymentMethod;
}>();

const { t } = useI18n();

const bankName = computed(() => {
  const m = props.method;
  if (m.type === 'us_bank_account') {
    return m.us_bank_account?.bank_name ?? '';
  }
  return '';
});

const last4 = computed(() => {
  const m = props.method;
  switch (m.type) {
    case 'card':
      return m.card?.last4 ?? '';
    case 'us_bank_account':
      return m.us_bank_account?.last4 ?? '';
    case 'sepa_debit':
      return m.sepa_debit?.last4 ?? '';
    case 'au_becs_debit':
      return m.au_becs_debit?.last4 ?? '';
    case 'bacs_debit':
      return m.bacs_debit?.last4 ?? '';
    default:
      return '';
  }
});

const typeLabel = computed(() => (props.method.type ?? '').toUpperCase().replace(/_/g, ' '));
</script>

<template>
  <div class="billing-payment-method-display">
    <BillingCardBrandIcon v-if="method.type === 'card'" :brand="method.card?.brand" />
    <BillingLinkBrandIcon v-else-if="method.type === 'link'" />
    <span v-else class="text-sm uppercase text-neutral-400">{{ typeLabel }}</span>
    <span v-if="bankName" class="bank-name text-xs">{{ bankName }}</span>
    <span v-if="last4" class="last4">{{ t('billing_card_masked') }}{{ last4 }}</span>
  </div>
</template>

<style lang="scss" scoped>
.billing-payment-method-display {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
</style>
